<template>
  <div>
    <v-toolbar class="toolbar" color="primary" dark height="50rem">
      <v-toolbar-title class="mr-2">{{title}}</v-toolbar-title>
      <!-- <v-toolbar-title v-for="(el, index) in headers" :key="index" class="ml-0">{{$translate(el)}}</v-toolbar-title> -->
      <v-layout v-if="showProgress == true" row class="progress_container">
        <v-progress-linear v-model="progressBar" color="blue"></v-progress-linear>
        <v-btn slot="activator" class="cancel_button" icon @click="progressDialog = true">
          <v-icon>cancel</v-icon>
        </v-btn>
      </v-layout>
      <v-spacer></v-spacer>
      <v-btn v-if="toolBarCalendarInfo === true" icon @click="calendarInfoDialog = true">
        <v-icon>help_outline</v-icon>
      </v-btn>
      <v-btn v-if="webshopCalendarHelperInfo === true" icon @click="webshopCalendarHelperInfoDialog = true">
        <v-icon>help_outline</v-icon>
      </v-btn>
      <v-btn v-if="dashboardStatus > 0 && toolBarOptions === true && $store.getters.getUserIsCrowdScout" icon @click="triggerSetVisitorsForLocationDialog">
        <v-icon>traffic</v-icon>
      </v-btn>
      <v-btn v-if="dashboardStatus > 0 && toolBarOptions === true" icon @click="showSettingDialog">
        <v-icon>settings</v-icon>
      </v-btn>
      <v-tooltip bottom>
        <v-btn  slot="activator" icon @click="enlarge">
          <v-icon v-if="!large">fullscreen</v-icon>
          <v-icon v-else>fullscreen_exit</v-icon>
        </v-btn>
        <span v-if="!large">Enlarge</span>
        <span v-else>Shrink</span>
      </v-tooltip>
      <v-btn v-if="!mainMap && dashboardStatus > 0" icon @click="showDeleteDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-dialog v-model="progressDialog" max-width="290" hide-overlay>
      <v-card>
        <v-divider></v-divider>
        <v-card-actions>
          <div>
            <v-btn color="blue darken-1" flat @click="progressDialog = false">Close</v-btn>
            <v-btn color="blue darken-1" flat @click="disableProgress">Save</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="setVisitorsForLocationDialog" max-width="720" hide-overlay persistent>
      <v-card class="pa-2">
        <v-card-title
          class="headline"
          :style="`color: ${$vuetify.theme.primary}`"
        ><v-list-tile-avatar><v-img size="10" :src="require('@/assets/crowdScout/CrowdScout.png')" /></v-list-tile-avatar> Crowd management [{{pickedLocation.Name}}]</v-card-title>
        <v-divider></v-divider>
        <h3 class="mt-2 mb-2">Set the state of the location manually, for a time period of today.</h3>
        <v-radio-group @change="checkIfFilledIn()" v-model="crowdChoice" row >
          <v-layout class="ml-2 setStoplights" column align-center>
            <v-list-tile-avatar><v-img size="10" :src="require('@/assets/crowdScout/traffic-light-green.png')" /></v-list-tile-avatar>
            <p>Not crowded</p>
            <v-radio color="green" value="1"></v-radio>
          </v-layout>
          <v-layout class="setStoplights" column align-center>
            <v-list-tile-avatar><v-img size="10" :src="require('@/assets/crowdScout/traffic-light-yellow.png')" /></v-list-tile-avatar>
            <p>Medium crowded</p>
            <v-radio color="yellow" value="3"></v-radio>
          </v-layout>
          <v-layout column align-center>
            <v-list-tile-avatar><v-img size="10" :src="require('@/assets/crowdScout/traffic-light-red.png')" /></v-list-tile-avatar>
            <p>Fully crowded</p>
            <v-radio color="red" value="4"></v-radio>
          </v-layout>
        </v-radio-group>
        <v-layout row wrap>
          <v-flex v-if="!disableTimes" xs12 md4 class="ml-2 mr-4">
            <v-layout row align-center>
              <h4>{{$translate('CALENDAR_EVENT_STARTTIME')}}</h4>
              <h5 class="requiredField"> - {{$translate('REQUIRED')}}</h5>
            </v-layout>
            <v-text-field
              v-model="stateStartTime"
              class
              :disabled="disableTimes"
              :label="$translate('CALENDAR_EVENT_STARTTIME')"
              outline
              :rules="emptyStringRule"
              hint="Input: hh:mm"
              type="time"
              @change="checkIfFilledIn()"
            ></v-text-field>
          </v-flex>
          <v-flex v-if="!disableTimes" xs12 md4>
            <v-layout row align-center>
              <h4>{{$translate('CALENDAR_EVENT_ENDTIME')}}</h4>
              <h5 class="requiredField"> - {{$translate('REQUIRED')}}</h5>
            </v-layout>
            <v-text-field
              v-model="stateEndTime"
              class
              :disabled="disableTimes"
              :label="$translate('CALENDAR_EVENT_ENDTIME')"
              outline
              :rules="emptyStringRule"
              hint="Input: hh:mm"
              type="time"
              @change="checkIfFilledIn()"
            ></v-text-field>
          </v-flex>
        </v-layout>
<!--        <v-select-->
<!--          label="Main location"-->
<!--          v-model="pickedLocation.LocationId"-->
<!--          :items="allLocations"-->
<!--          item-text="Name"-->
<!--          item-value="Id"-->
<!--          class="mr-2 ml-2"-->
<!--          persistent-hint-->
<!--          required-->
<!--          @change="checkIfFilledIn()"-->
<!--        ></v-select>-->
<!--        <v-text-field-->
<!--          v-if="pickedLocation.hasOwnProperty('LocationId')"-->
<!--          min="0"-->
<!--          max="100"-->
<!--          type="number"-->
<!--          label="Set current visitors of the location"-->
<!--          v-model="pickedLocation.Visitors"-->
<!--          required-->
<!--          @input="checkIfFilledIn()"-->
<!--        />-->
        <v-divider></v-divider>
          <v-card-actions>
              <v-layout row justify-end align-end>
                <v-btn color="blue darken-1" flat @click="setVisitorsForLocationDialog = false">Close</v-btn>
                <v-btn color="blue darken-1" :disabled="disableButton" flat @click="setDensityState">Send</v-btn>
              </v-layout>
          </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="calendarInfoDialog" max-width="500" hide-overlay>
      <!-- <div class="slot_container"> -->
      <v-card>
        <v-card-title><h3>Help</h3></v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p>
            <b>{{$translate('LEGENDA_GREY')}}</b><br/>
            {{$translate('LEGENDA_QUADRANT_GREY')}}
          </p>
          <p>
            <b>{{$translate('LEGENDA_BLUE')}}</b><br/>
            {{$translate('LEGENDA_QUADRANT_BLUE')}}
          </p>
          <p>
            <b>{{$translate('LEGENDA_RED')}}</b><br/>
            {{$translate('LEGENDA_QUADRANT_RED')}}
          </p>
          <p>
            <b>{{$translate('LEGENDA_YELLOW_BORDER')}}</b><br/>
            {{$translate('LEGENDA_QUADRANT_YELLOW_BORDER')}}
          </p>
          <p>
            <b>
              <v-icon small>report_problem</v-icon>
              {{$translate('LEGENDA_RESTRICTIONS')}}
            </b>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-layout align-end justify-end>
            <v-btn color="primary" round @click="calendarInfoDialog = false">close</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="webshopCalendarHelperInfoDialog" max-width="500" hide-overlay>
      <v-card>
        <v-card-title><h3>Help</h3></v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p>
            <b>{{$translate('WEBSHOP_QUADRANT_RED_HEADER')}}</b><br/>
            {{$translate('WEBSHOP_QUADRANT_RED_DETAILS')}}
          </p>
          <p>
            <b>{{$translate('WEBSHOP_QUADRANT_BLUE_HEADER')}}</b><br/>
            {{$translate('WEBSHOP_QUADRANT_BLUE_DETAILS')}}
          </p>
          <p>
            <b>{{$translate('WEBSHOP_QUADRANT_ORANGE_HEADER')}}</b><br/>
            {{$translate('WEBSHOP_QUADRANT_ORANGE_DETAILS')}}
          </p>
          <p>
            <b>{{$translate('WEBSHOP_QUADRANT_GREEN_HEADER')}}</b><br/>
            {{$translate('WEBSHOP_QUADRANT_GREEN_DETAILS')}}
          </p>
          <p>
            <b>{{$translate('WEBSHOP_QUADRANT_GREY_HEADER')}}</b><br/>
            {{$translate('WEBSHOP_QUADRANT_GREY_DETAILS')}}
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-layout align-end justify-end>
            <v-btn color="primary" round @click="webshopCalendarHelperInfoDialog = false">close</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSetting" max-width="500" hide-overlay>
      <!-- <div class="slot_container"> -->
      <v-card>
        <slot name="settingContent"></slot>
        <v-divider></v-divider>
        <v-card-actions>
            <v-layout align-end justify-end>
            <v-btn color="secondary" round @click="showSettingDialog">Close</v-btn>
            <v-btn color="primary" round @click="storeSetting">Save</v-btn>
            </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="290" hide-overlay>
      <v-card>
        <v-card-title class="headline">Are you sure you want to close?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" round @click="dialogDelete = false">No</v-btn>
          <v-btn color="primary" round @click="deleteContainer">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import * as dssRequest from "../../api/dssRequest";
import _ from "lodash";
export default {
  name: "OperationalScreen_QuadrantToolbar",
  props: {
    stateStartTime: '',
    stateEndTime: '',
    componentId: String,
    headers: Array,
    title: String,
    mainMap: {
      type: Boolean,
      default: false
    },
    toolBarOptions: Boolean,
    toolBarCalendarInfo: Boolean,
    webshopCalendarHelperInfo: Boolean
  },
  computed: {
    ...mapGetters({
      dashboardStatus: "getDashboardStatus"
    })
  },
  created() {
    if (this.headers[0] == "INCIDENT_TITLE") {
      this.enableAddIncident = true;
    }
  },
  mounted() {
    this.$store.commit('setTitleOfMap', this.title);
    },
  data() {
    return {
      emptyStringRule: [
        v => !!v || "Field is required",
        v => v != 0 || "Field must at least be 1 char long!"
      ],
      calendarInfoDialog: false,
      webshopCalendarHelperInfoDialog: false,
      disableTimes: false,
      disableButton: true,
      pickedLocation: {},
      allLocations: [],
      crowdChoice: null,
      setVisitorsForLocationDialog: false,
      progressDialog: false,
      showProgress: false,
      progressBar: 0,
      dialogDelete: false,
      dialogSetting: false,
      large: false,
      showRescheduleBtn: false,
      enableAddIncident: false,
      addIncidentClicked: false,
      save: true,
    };
  },
  methods: {
    checkIfFilledIn(){
      this.disableTimes = this.crowdChoice === '1';
      if (this.crowdChoice === '1' && this.pickedLocation !== '') {
      this.disableButton = false;
      } else if (this.crowdChoice !== null && this.crowdChoice !== '1' && this.pickedLocation.LocationId !== '') {
        if (this.stateEndTime.split(':') <= this.stateStartTime.split(':')){
          this.disableButton = true;
        } else {
          this.disableButton = false;
        }
      } else {
        this.disableButton = true;
      }
    },
    setDensityState() {
      // This function is used to set the visitors manually for demo purposes
      let payload = {};


        payload = {
          DensityCategory: this.crowdChoice,
          StartTime: this.stateStartTime,
          EndTime: this.stateEndTime
        };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call setDensityState  was successful",
            response
          );
          this.setVisitorsForLocationDialog = false;
        },
        error => {
          console.log(
            "The generic call setDensityState was not successful",
            error
          );
        },
        "setDensityState",
        this.pickedLocation.LocationId,
        payload
      );
    },
    triggerSetVisitorsForLocationDialog() {
      this.$store.commit('setTitleOfMap', this.title);
      if (!this.$store.getters.getUserIsCrowdScout) {
        return;
      }
        // This function is used to retrieve the locations to select a main location for the account
        let payload = {};
        // let object = "";

        // // Check if user is on partner env. or account env. to visualise the locations regarding the env.
        // if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
        //   payload.PartnerId = -1;
        //   object = this.$store.getters.getCurrentAccountId;
        // } else {
        //   payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
        //   object =
        //     this.$store.getters.getCurrentAccountId +
        //     "_UG_" +
        //     this.$store.getters["auth/partnerId"];
        // }

        dssRequest.doRequest(
          response => {
            console.log(
              "The generic call getLocations to pick a main location for the account was successful",
              response
            );
            this.pickedLocation = {};
            for (const [key, value] of Object.entries(response.data.Locations)) {
              if(value.Name === this.title){
                this.pickedLocation.LocationId = value.Id;
                this.pickedLocation.Name = value.Name;
              }
              this.allLocations.push(value);
            }
            this.stateStartTime = '';
            this.stateEndTime = '';
            this.crowdChoice = null;
            this.setVisitorsForLocationDialog = true;
          },
          error => {
            console.log(
              "The generic call getLocations to pick a main location for the account was not successful",
              error
            );
          },
          "getLocations",
          this.$store.getters.getCurrentAccountId,
          payload
        );
    },
    disableProgress() {
      this.progressDialog = false;
      this.showProgress = false;
    },
    enlarge() {
      this.large = !this.large;
      // if (!this.large) {
      //   window.EventBus.fire("enlarge", this.componentId);
      //   this.large = true;
      // } else {
      //   this.large = false;
      //   window.EventBus.fire("dosmall", this.componentId);
      // }
      window.EventBus.fire("toggleSizeQuadrant", this.componentId);
    },
    showSettingDialog() {
      this.dialogSetting = !this.dialogSetting;
      if (this.dialogSetting) {
        if (this.headers.length > 0 && this.headers[0] == "EVENT_TITLE") {
          this.showRescheduleBtn = true;
        } else {
          this.showRescheduleBtn = false;
        }
      }
    },
    fireAddIncident() {
      this.addIncidentClicked = !this.addIncidentClicked;
      if (this.enableAddIncident) {
        if (this.addIncidentClicked) {
          window.EventBus.fire("showAddIncident", true);
        } else {
          if (!this.addIncidentClicked) {
            window.EventBus.fire("closeAddIncident", true);
          }
        }
      }
    },
    rescheduleArrivals() {
    },
    showDeleteDialog() {
      this.dialogDelete = !this.dialogDelete;
    },
    storeSetting() {
      this.dialogSetting = false;
      this.showRescheduleBtn = false;
      window.EventBus.fire("storeSettings" + this.componentId, {});
    },
    deleteContainer() {
      this.dialogDelete = false;
      console.log("Laurens this.componentId", this.componentId);

      window.EventBus.fire("removeQuadrant", this.componentId);
    }
  }
};
</script>
<style lang='css'>
.toolbar {
  max-height: 4em;
  height: 4em !important;
  box-shadow: 0 0px 0px 0px rgba(0, 0, 0, 0) !important;
}
.slot_container {
  z-index: 15;
}
.progress_container {
  padding: 0px 0px 0px 25px;
  height: 35px;
  width: 300px;
}
.cancel_button {
  margin: 0px 0px 0px 0px !important;
}

  .setStoplights{
    margin-right: 6em;
  }
</style>
